const REQUIRED_CONFIG_KEYS = [
  'coreurl',
  'aiapiurl',
  'alertapiurl',
  'payloadapiurl',
  'robot_status_ws',
  'robot_control_ws',
  'robot_alert_ws',
  'keycloakURL',
  'keycloakRealm',
  'keycloakClientId',
];

const runtimeConfig = window.__RUNTIME_CONFIG__;

if (!runtimeConfig) {
  throw new Error(
    'Runtime configuration is missing. Expected /config/runtime-config.js to define window.__RUNTIME_CONFIG__.'
  );
}

const missingKeys = REQUIRED_CONFIG_KEYS.filter(
  (key) => typeof runtimeConfig[key] !== 'string' || runtimeConfig[key].trim() === ''
);

if (missingKeys.length > 0) {
  throw new Error(`Runtime configuration is missing required values: ${missingKeys.join(', ')}`);
}

const Config = Object.freeze({ ...runtimeConfig });

export default Config;